'use strict';

var _ = require('lodash');

function PageManager (drawer) {
  this.drawer = drawer;
  this.active = '';
  this._pages = [];
  this._pageIndices = {}; // desired page indices... not all pages will have one
}

///////////////////////////////////////////////////////////////////////////////////////////////////
// Getters
///////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Return the currently active page
 * 
 * @return {String} page id
 */
PageManager.prototype.getActive = function () {
  return this.active;
};

/**
 * Returns the number of registered pages
 * 
 * @return {Number}
 */
PageManager.prototype.getCount = function () {
  return this._pages.length;
};

/**
 * Returns the index of the page, i.e. indicates when the page was registered in relation to 
 * the other pages
 * 
 * @param  {String} id page id
 */
PageManager.prototype.getPageIndex = function (id) {
  return this._pages.indexOf(id);
};

/**
 * Return a boolean indicting whether or not the specified page is active
 * 
 * @param  {String}  id page id
 * @return {Boolean} true if active
 */
PageManager.prototype.isActive = function (id) {
  return id === this.active;
};

/**
 * Returns a boolean indicating whether or not the specified page is registered
 * 
 * @param  {String}  id page id
 * @return {Boolean} true if registered
 */
PageManager.prototype.pageExists = function (id) {
  return !!~this._pages.indexOf(id);
};

///////////////////////////////////////////////////////////////////////////////////////////////////
// Setters
///////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Register a page
 * 
 * @param  {String} id page id
 */
PageManager.prototype.register = function (id, index) {
  if (!this.pageExists(id)) {

    // save the desired index
    if (index !== undefined && index !== null) {
      index = parseInt(index);
      this._pageIndices[id] = index;
    } else {
      index = this._pages.length;
    }

    this._pages.splice(index,0,id);
    this._orderPages();
  } else {
    throw new Error('Page already registered: ' + id);
  }
};

/**
 * Set the specified page as "active"
 * 
 * @param {String} id page id
 */
PageManager.prototype.setActive = function (id) {
  if (this.pageExists(id)) {
    this.active = id;
  } else {
    throw new Error('Page does not exist: ' + id);
  }
};

/**
 * Remove the specified page
 * 
 * @param  {String} id page id
 */
PageManager.prototype.removePage = function (id) {
  if (id === this.active) {
    this.active = '';
  }

  var index = this._pages.indexOf(id);

  if (index !== -1) {
    this._pages.splice(index,1);
  }
};

///////////////////////////////////////////////////////////////////////////////////////////////////
// Helpers
///////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Orders the pages given their desired location. This is run after every page is registered to
 * ensure corrent order. The debounce is used to make sure it only runs after all pages have been
 * registered.
 */
PageManager.prototype._orderPages = _.debounce(function () {
  _.forEach(this._pageIndices, function (index, id) {
    var currentIndex = this.getPageIndex(id); // 1
    for (var i = 0; i < this._pages.length; i++) {
      var id_ = this._pages[i];
      if (index === i && id_ !== id) {        
        this._pages[index] = id;
        this._pages[currentIndex] = id_;
        break;
      }
    }
  }.bind(this));
}, 1);

module.exports = {
  _instances: {},
  create: function (drawerId) {
    var viewManager = this._instances[drawerId];

    if (!viewManager) {
      viewManager = new PageManager(drawerId);
      this._instances[drawerId] = viewManager;
    }

    return viewManager;
  },
  destroy: function (drawerId) {
    delete this._instances[drawerId];
  },
  destroyAll: function () {
    _.forEach(this._instances, function (instance, drawerId) {
      delete this._instances[drawerId];
    }.bind(this));
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/page/PageManager.js